import { currentUserToken, getAPIBaseUrl } from "../utils/constants";
import { createApiClient } from "./createApiClient";

export default createApiClient({
  baseURL: getAPIBaseUrl(),
  getToken: currentUserToken,
});
